<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMail_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m22.054 5.445-7.562 6.724a3.75 3.75 0 0 1-4.984 0L1.946 5.445A2.99 2.99 0 0 1 4.5 4h15a2.99 2.99 0 0 1 2.554 1.445Zm.077 11.968-5.004-5.58L22.5 7.056V16c0 .514-.141.99-.369 1.413Zm-6.642-4.123A5.241 5.241 0 0 1 12 14.616a5.241 5.241 0 0 1-3.489-1.326l-.517-.46-5.106 5.693A2.976 2.976 0 0 0 4.5 19h15c.594 0 1.145-.178 1.611-.477l-5.105-5.693-.517.46ZM1.5 16V7.056l5.373 4.777-5.004 5.58A2.963 2.963 0 0 1 1.5 16Z"
        clip-rule="evenodd"
    />
</svg>
